module.exports = __webpack_public_path__ + "static/img/ramadanstyle.4d93172.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ramadanstyle.png
// module id = D7bZ
// module chunks = 7